var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "1_ico/calender") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "1_ico/calender",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-16",
    transform: "translate(2.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15,17 L1,17 C0.448,17 0,16.553 0,16 L0,5 C0,4.447 0.448,4 1,4 L15,4 C15.552,4 16,4.447 16,5 L16,16 C16,16.553 15.552,17 15,17 Z",
    id: "Stroke-1",
    stroke: "#204359",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,7 L0,7 L0,5 C0,4.447 0.448,4 1,4 L15,4 C15.552,4 16,4.447 16,5 L16,7 Z",
    id: "Fill-3",
    fill: "#204359"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#204359",
    points: "3 4 5 4 5 0 3 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "#204359",
    points: "11 4 13 4 13 0 11 0"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-8",
    fill: "#204359",
    points: "2 11 4 11 4 9 2 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "#204359",
    points: "5 11 7 11 7 9 5 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-10",
    fill: "#204359",
    points: "8 11 10 11 10 9 8 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-11",
    fill: "#204359",
    points: "11 11 13 11 13 9 11 9"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-12",
    fill: "#204359",
    points: "2 14 4 14 4 12 2 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-13",
    fill: "#204359",
    points: "5 14 7 14 7 12 5 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-14",
    fill: "#204359",
    points: "8 14 10 14 10 12 8 12"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-15",
    fill: "#204359",
    points: "11 14 13 14 13 12 11 12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c24f9f773a4048e654f372cd1c7fc107.svg";
export { ForwardRef as ReactComponent };